import React, { useState, useEffect } from "react";
import { Container, Row, Col, Table, Form, Spinner } from "react-bootstrap";
import { FaEdit, FaTrash, FaPlus } from "react-icons/fa";
import { Link } from "react-router-dom";
import { usePagination } from "../hooks/usePagination";
import Pagination from "../Components/Pagination";
import api from "../services/api";
import "./CustomerList.css";

const ProductList = () => {
  const [search, setSearch] = useState("");
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch products from API
  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const response = await api.post("/product_list.php", {});
      
      if (response.data.head.code === 200) {
        const transformedData = response.data.body.map(product => ({
          id: product.id,
          // productCode: `PROD${String(product.id).padStart(3, '0')}`, // Generate product code
          productCode: product.product_code,
          productName: product.name,
          supplierName: product.supplier_name,
          unit: product.unit_name,
          hsnCode: product.hsn_code,
          openingStock: product.opening_stock,
          currentStock: product.opening_stock // Using opening as current for now
        }));
        
        setProducts(transformedData);
      } else {
        setError(response.data.head.msg || "Failed to fetch products");
      }
    } catch (err) {
      console.error("Error fetching products:", err);
      setError("Failed to load products. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // Delete product handler with API integration
  const handleDelete = async (id, productName) => {
    if (!window.confirm(`Are you sure you want to delete ${productName}?`)) {
      return;
    }

    try {
      const response = await api.post("/product_delete.php", { id });
      
      if (response.data.head.code === 200) {
        // Remove from local state
        setProducts(products.filter((p) => p.id !== id));
        alert("Product deleted successfully!");
        window.location.reload();
      } else {
        alert("Failed to delete product: " + response.data.head.msg);
      }
    } catch (err) {
      console.error("Error deleting product:", err);
      alert("Failed to delete product. Please try again.");
    }
  };

  // Filter products based on search
  const filteredProducts = products.filter((product) => {
    if (!search) return true;
    const query = search.toLowerCase();
    return (
      String(product.id).toLowerCase().includes(query) ||
      (product.productCode && product.productCode.toLowerCase().includes(query)) ||
      (product.productName && product.productName.toLowerCase().includes(query)) ||
      (product.unit && product.unit.toLowerCase().includes(query)) ||
      (product.hsnCode && product.hsnCode.toLowerCase().includes(query)) ||
      (product.supplierName && product.supplierName.toLowerCase().includes(query))
    );
  });

  // Pagination hook
  const {
    currentPage,
    totalPages,
    currentItems: currentProducts,
    handlePageChange,
    indexOfFirstItem
  } = usePagination(filteredProducts, 10);

  if (loading) {
    return (
      <Container fluid className="outer-container my-3">
        <div className="text-center py-5">
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
          <p className="mt-3">Loading products...</p>
        </div>
      </Container>
    );
  }
{/*
  if (error) {
    return (
      <Container fluid className="outer-container my-3">
        <div className="alert alert-danger" role="alert">
          {error}
          <button className="btn btn-sm btn-outline-danger ms-3" onClick={fetchProducts}>
            Retry
          </button>
        </div>
      </Container>
    );
  }
*/}
  return (
    <Container fluid className="outer-container my-3">
      <h2 className="text-center mb-3">Product Management</h2>
      
      {/* Search and Add Product Section */}
      <Row className="mb-3 align-items-center">
        <Col xs={12} md={6} lg={4} className="mb-2 mb-md-0">
          <Form.Control
            placeholder="Search by product code, name"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </Col>

        <Col xs={12} md={6} lg={8} className="d-flex justify-content-md-end">
          <Link
            to="/addproduct"
            className="btn-top d-inline-flex align-items-center"
          >
            <FaPlus className="me-2" /> Add Product
          </Link>
        </Col>
      </Row>

      {/* Table Section */}
      <div className="table-pagination-wrapper">
        <div className="table-pagination-content">
          <Table bordered responsive className="table-striped customer-table">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Product Code</th>
                <th>Product Name</th>
                {/* <th>Unit</th>
                <th>HSN Code</th>
                <th>Current Stock</th> */}
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {currentProducts.map((product, index) => (
                <tr key={product.id}>
                  <td>{indexOfFirstItem + index + 1}</td>
                  <td>{product.productCode}</td>
                  <td>{product.productName}</td>
                  {/* <td>{product.unit}</td>
                  <td>{product.hsnCode}</td>
                  <td>{product.currentStock}</td> */}
                  <td>
                    <div className="action-icons">
                      <Link
                        to={`/editproduct/${product.id}`}
                        className="me-2"
                        title="Edit Product"
                      >
                        <FaEdit className="edit-icon" />
                      </Link>
                      <FaTrash
                        className="delete-icon"
                        title="Delete Product"
                        onClick={() => handleDelete(product.id, product.productName)}
                      />
                    </div>
                  </td>
                </tr>
              ))}
              {currentProducts.length === 0 && (
                <tr>
                  <td colSpan="8" className="text-center">
                    {search ? "No products found matching your search" : "No products found"}
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>

      {/* Pagination */}
      {totalPages > 1 && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
        />
      )}
    </Container>
  );
};

export default ProductList;